import { render } from "./TransitionFadeCss.vue?vue&type=template&id=1ff22bf1"
import script from "./TransitionFadeCss.vue?vue&type=script&lang=js"
export * from "./TransitionFadeCss.vue?vue&type=script&lang=js"

import "./TransitionFadeCss.vue?vue&type=style&index=0&id=1ff22bf1&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__